export enum ThemesEnum {
  PF = 'PF',
  PJ = 'PJ',
}

export enum ToranjaThemesEnum {
  PF_LIGHT = 'pf-light',
  PF_DARK = 'pf-dark',
  PJ_LIGHT = 'pj-light',
  PJ_DARK = 'pj-dark',
}
